import { Frame } from 'stompjs'
import { AssetWebSocket } from '../incident-management/web-socket'
import { NotifyWebSocket } from './web-socket-model-notify'
import store from '../store'
import { UpdateNotifySuccessEvent } from '../authorization-module/people/state-event'
import { UpdateNotifyWebSocketSuccessEvent } from './state-event'
import { message } from 'antd'

function onIncidentEvent(frame: Frame) {
    const event: NotifyWebSocket = JSON.parse(frame.body)
    console.log(event)
    if (event.httpStatus.toString() === '202') {
        console.log('checking TenantService Uploaded')
    } else if (event.httpStatus.toString() === '429') {
        if (event) {
            const data = JSON.parse(JSON.stringify(event.responseData))
            message.error(data?.messageFail)
        }
    } else {
        store.dispatch(UpdateNotifySuccessEvent.build(store.getState().notify + 1))
        store.dispatch(UpdateNotifyWebSocketSuccessEvent.build(event))
    }
    // if (event.httpStatus === ImportPMStatus.Done) {
    // } else if (event.httpStatus === ImportPMStatus.Error) {
    //     // store.dispatch(IncidentUpdatedEvent.build(event.incident!!))
    // } else if (event.httpStatus === ImportPMStatus.Failed) {
    //     // store.dispatch(IncidentDeletedEvent.build(event.incidentId))
    // }
}

let isSubscribed = false
export const NotifyWebSocketChannel = {
    subscribe: (email:string) => {
        if (!isSubscribed) {
            AssetWebSocket.getClient()
                .then((client) => {
                    client.subscribe(AssetWebSocket.buildDestination2(`${email}/importPM`), onIncidentEvent)
                    isSubscribed = true
                })
                .catch((_err) => {
                // message.error(`Failed web socket connection. ${err}`)
                })
        }
    }
}
